// 9fbef606107a605d69c0edbcd8029e5d
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { parseBoolean } from '@tcp/core/src/utils/utils';
import {
  getAPIConfigForAdobe,
  getSessionDataForAdobe,
  getUserState,
} from '@tcp/core/src/adobeAnalytics/adobe.selectors';
import { getStyliticsCarouselBgColor } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { openQuickViewWithValues } from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.actions';
import { fetchShopByLookStyliticsRequest } from './ShopByLookStylitics.actions';
import {
  getShopByLookStyliticsError,
  isShopByLookStyliticsLoading,
  getShopByLookStyliticsDataByTag,
} from './ShopByLookStylitics.selector';
import ShopByLookStylitics from '../views/ShopByLookStylitics.view';
import {
  getTagName,
  generateUniqueKey,
  isRedirectToPDPEnabled,
  getImageUrl,
  getListAnimation,
  getItemProps,
} from '../utils/ShopByLookStylitics.util';

export const mapStateToProps = (state, ownProps) => {
  const {
    slot,
    MAX_ITEM = '',
    IMG_COL1 = '',
    IMG_COL2 = '',
    IMG_COL3 = '',
    IMG_COL4 = '',
    IMG_COL1_FR = '',
    IMG_COL2_FR = '',
    IMG_COL3_FR = '',
    IMG_COL4_FR = '',
    IMG_COL1_ES = '',
    IMG_COL2_ES = '',
    IMG_COL3_ES = '',
    IMG_COL4_ES = '',
    pageCategoryId,
    IMG_M_COL1 = '',
    IMG_M_COL2 = '',
    IMG_M_COL3 = '',
    IMG_M_COL4 = '',
    IMG_M_COL1_FR = '',
    IMG_M_COL2_FR = '',
    IMG_M_COL3_FR = '',
    IMG_M_COL4_FR = '',
    IMG_M_COL1_ES = '',
    IMG_M_COL2_ES = '',
    IMG_M_COL3_ES = '',
    IMG_M_COL4_ES = '',
    NAVIGATION = '',
    CATEGORY_TAG_HP,
    DISPLAY_TYPE = '',
    aspectRatioObj = {},
    tileHeightValue = 0,
    isInGridPromo = false,
    isFullRowView = false,
    isSingleTileView = false,
    isDoubleTileView = false,
    tileBadgeHeightValue = 0,
    isOtherPagesSetup = false,
    OUT_OF_STOCK_BG_COLOR = '',
    GALLERY_PRODUCT_REVEAL = '',
    OUT_OF_STOCK_TEXT_COLOR = '',
    IS_COMPLETE_TAG_NAME = false,
    SHOW_OUT_OF_STOCK_OVERLAY = false,
    processedBreadCrumbs,
    IS_NON_CLICKABLE_VIEW = false,
    pageSlotName = '',
  } = ownProps;

  const slotNameVal = isEmpty(slot) ? pageSlotName : slot;
  const maxCountVal = isEmpty(MAX_ITEM) ? 10 : MAX_ITEM;
  const tagValue = getTagName(IS_COMPLETE_TAG_NAME, CATEGORY_TAG_HP);
  const uniqueKey = generateUniqueKey(pageCategoryId, slotNameVal, tagValue, isOtherPagesSetup);
  const isRedirectToPDP = isRedirectToPDPEnabled(NAVIGATION);
  const isNonClickablePromo = parseBoolean(IS_NON_CLICKABLE_VIEW);
  const columnImages = {
    firstColumnImage: getImageUrl(
      IMG_COL1,
      IMG_M_COL1,
      IMG_COL1_FR,
      IMG_M_COL1_FR,
      IMG_COL1_ES,
      IMG_M_COL1_ES
    ),
    secondColumnImage: getImageUrl(
      IMG_COL2,
      IMG_M_COL2,
      IMG_COL2_FR,
      IMG_M_COL2_FR,
      IMG_COL2_ES,
      IMG_M_COL2_ES
    ),
    thirdColumnImage: getImageUrl(
      IMG_COL3,
      IMG_M_COL3,
      IMG_COL3_FR,
      IMG_M_COL3_FR,
      IMG_COL3_ES,
      IMG_M_COL3_ES
    ),
    fourthColumnImage: getImageUrl(
      IMG_COL4,
      IMG_M_COL4,
      IMG_COL4_FR,
      IMG_M_COL4_FR,
      IMG_COL4_ES,
      IMG_M_COL4_ES
    ),
  };
  const animationProps = getListAnimation(GALLERY_PRODUCT_REVEAL);
  const {
    maxItemCount,
    isMultiTileDesign,
    isSingleTileDesign,
    isScrollableCarousel,
    isCombineImageDesign,
  } = getItemProps(
    DISPLAY_TYPE,
    maxCountVal,
    isFullRowView,
    isSingleTileView,
    isDoubleTileView,
    isOtherPagesSetup,
    isNonClickablePromo
  );
  const designProps = {
    maxItem: maxItemCount,
    isMultiTileDesign,
    isSingleTileDesign,
    isScrollableCarousel,
    isCombineImageDesign,
  };
  const stylingProps = {
    aspectRatioObj,
    tileHeightValue,
    tileBadgeHeightValue,
    slotName: slotNameVal,
    categoryTag: CATEGORY_TAG_HP,
    oosBgColor: OUT_OF_STOCK_BG_COLOR,
    oosTextColor: OUT_OF_STOCK_TEXT_COLOR,
    carouselBgColor: getStyliticsCarouselBgColor(state) || '',
  };
  const viewTypeFlags = {
    isInGridPromo,
    isSingleTileView,
    isDoubleTileView,
    isFullRowView: isFullRowView || isOtherPagesSetup,
  };

  const behaviorFlags = {
    isRedirectToPDP,
    isNonClickablePromo,
    showOosOverlay: parseBoolean(SHOW_OUT_OF_STOCK_OVERLAY),
  };

  const adobeAnalyticsProps = {
    uniqueKey,
    processedBreadCrumbs,
    User: getUserState(state),
    APIConfig: getAPIConfigForAdobe(state),
    session: getSessionDataForAdobe(state),
  };

  const styliticsDataState = {
    error: getShopByLookStyliticsError(state, uniqueKey),
    isLoading: isShopByLookStyliticsLoading(state, uniqueKey),
    shopByLookStyliticsData: getShopByLookStyliticsDataByTag(state),
  };

  return {
    tagValue,
    uniqueKey,
    designProps,
    stylingProps,
    columnImages,
    viewTypeFlags,
    behaviorFlags,
    animationProps,
    isOtherPagesSetup,
    styliticsDataState,
    adobeAnalyticsProps,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  onQuickViewOpenClick: (payload) => dispatch(openQuickViewWithValues(payload)),
  fetchShopByLookStyliticsData: (tagName, count, uniqueKey, isRedirectToPDP) =>
    dispatch(fetchShopByLookStyliticsRequest(tagName, count, uniqueKey, isRedirectToPDP)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShopByLookStylitics);
